{
  "title": "My Classes",
  "empty_list_title": "No Classes",
  "empty_list_description": "You are not enrolled in any classes yet. Classes will appear here once you have been assigned to them.",
  "educator": "Educator",
  "team": "Team",
  "schedule": "Schedule",
  "time": "{{day}}: {{start}} - {{end}}",
  "temporary_relief_educator": "Temporary Relief Educator",
  "permanent_relief_listing_educator": "Permanent Relief Educator",
  "change_class": "Change Class",
  "withdraw": "Withdraw",
  "withdraw_description": "This action cannot be undone. Once you have withdrawn from this clas you cannot re-join it.",
  "flash.withdrawn": "Withdrawing the student."
}
